module.exports = __webpack_public_path__ + "img/daren_7.b1be1cfe.png";